import "numeral/locales"; // pro nahrání lokalizací

import numeral from "numeral";

import { FormatProviderInputValues, FormatProviderParams } from "@multiweb/types/multiweb";

export const NUMERAL_DATA_FORMAT = "numeralDataFormat";

export const numeralDataFormat = (
    val: FormatProviderInputValues,
    { displayFormat, culture }: FormatProviderParams,
) => {
    if (numeral.locales[culture])
        numeral.locale(culture);
    //některé localizace jsou uvedeny jen na základě ISO 639
    else if (culture && culture.split("-").length > 0 && numeral.locales[culture.split("-")[0]])
        numeral.locale(culture.split("-")[0]);
    //pokud daná kultura není podporována pak nastavím výchozí anglickou
    else
        numeral.locale("en");

    return numeral(val).format(displayFormat);
};

// V lokalizaci numeralu je chyba, kdy je miliarda v češtiny označena z angličtiny jako bilion
export const numeralCsLocales = () => {
    numeral.locales["cs"] = {
        delimiters: {
            thousands: " ",
            decimal: ",",
        },
        abbreviations: {
            thousand: "tis.",
            million: "mil.",
            billion: "mld.",
            trillion: "bil.",
        },
        ordinal: function() {
            return ".";
        },
        currency: {
            symbol: "Kč",
        },
    };
};
numeralCsLocales();
